export const noop = () => {
	console.log('no operation');
};
